import { isEmpty } from 'lodash';

export type EditItemFormType = {
  _id: string;
  name: string;
  category: any;
  code: string | null;
  quantity: number;
  unit: string | null;
  image: string | null;
  location: string | null;
};

export type AddItemFormType = {
  name: string;
  category: any;
  code: string | null;
  quantity: number;
  unit: string | null;
  image: string | null;
  location: string | null;
};

export const validateNewItem = ({
  name,
  category,
  quantity,
  unit,
}: AddItemFormType) => {
  let errors: any = {};

  if (isEmpty(name)) {
    errors.name = "Nama barang wajib diisi";
  };

  if (isEmpty(category)) {
    errors.category = "Kategori wajib diisi";
  };

  if (Number(quantity) && Number(quantity) === 0) {
    errors.quantity = "Jumlah barang wajib diisi";
  };

  if (isEmpty(unit)) {
    errors.unit = "Satuan barang wajib diisi";
  };

  return {
    errors,
    isValid: isEmpty(errors),
  };
};

export const validateEditItem = ({
  _id,
  name,
  category,
  quantity,
  unit,
}: EditItemFormType) => {
  let errors: any = {};

  if (isEmpty(_id)) {
    errors.name = "Item ID is required";
  };

  if (isEmpty(name)) {
    errors.name = "Nama barang wajib diisi";
  };

  if (isEmpty(category)) {
    errors.category = "Kategori wajib diisi";
  };

  if (Number(quantity) && Number(quantity) === 0) {
    errors.quantity = "Jumlah barang wajib diisi";
  };

  if (isEmpty(unit)) {
    errors.unit = "Satuan barang wajib diisi";
  };

  return {
    errors,
    isValid: isEmpty(errors),
  };
};